import React, { useCallback, useMemo } from 'react';
import { useHistory } from 'react-router';
import { Link } from 'react-router-dom';

import { Avatar } from '@mui/material';

import RevisionSelect from 'pages/item/v2/components/RevisionSelect';
import Utils from 'utils/Utils';

import useStyles from './styles';

interface Props {
    id: string;
    published: string;
    reporter: string | undefined;
    href: string | undefined;
    type: string;
    className?: string;
}

const Summary: React.FC<Props> = ({ id, href, reporter, type, published, className }) => {
    const { classes, cx } = useStyles();
    const history = useHistory();
    const handleImageClick = useCallback(() => history.push(`/search?query=type:${type}`), [history, type]);

    const source = useMemo(() => {
        if (reporter) {
            return reporter[0].toUpperCase() + reporter.slice(1);
        }
        if (href) {
            const { host } = new URL(href);
            return host;
        }
        return null;
    }, [href, reporter]);

    return (
        <div className={cx(classes.container, className)}>
            <div className={classes.text}>
                <Link to={`/search?query=type:${type}`}>
                    <Avatar
                        className={classes.avatar}
                        src={Utils.getImage(type)}
                        onClick={handleImageClick}
                        alt={type}
                    />
                </Link>
                {source ? <span className={classes.source}>{source}</span> : null}
                <span className={classes.id}>{id}</span>
            </div>
            <RevisionSelect published={new Date(published)} />
        </div>
    );
};

export default Summary;
